<template>
    <component
        :is="clickable ? 'button' : 'div'"
        :disabled="disabled"
        :class="[
            faded
                ? 'bg-gray-300 text-white opacity-50'
                : [
                      accentBorder
                          ? `border-${modelClass}-accent`
                          : `border-${modelClass}`,
                      `bg-${modelClass} text-${modelClass}-accent`,
                  ],
            ,
            {
                'hover:scale-105 transition': clickable,
            },
            { 'transition-colors': !clickable },
            'disabled:cursor-not-allowed font-header capitalize text-sm font-medium rounded-full border h-fit select-none px-2 py-[1px] w-fit duration-200 truncate',
        ]"
        v-text="
            $getBaseModelTranslation({
                modelName: modelClass,
            })
        "
    />
</template>

<script>
export default {
    props: {
        modelClass: {
            type: String,
            required: true,
        },
        faded: {
            type: Boolean,
            default: false,
        },
        accentBorder: {
            type: Boolean,
            default: false,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
